export default __webpack_public_path__ + "static/media/why-motion-banner.a2ae28d1.png";